module.exports = __webpack_public_path__ + "static/media/pureLogo.836a591b.png";